module.exports = __webpack_public_path__ + "static/media/20ECE32.ee6faf49.jpg";